import Segment from '../../shared/segment';
import { CheckSmsKeyRequestReturnType } from '../../../api/temp-user';
import { APIErrorType } from '../../../api';
import MobileView from './mobile-view';
import ResendView from './resend-view';
import SmsKeyForm from './sms-key-form';

export type SmsKeyFormPropsType = {
  mobile: string;
  noLabel: boolean;
  onUpdateMobile: () => void;
  onSubmit: (data: CheckSmsKeyRequestReturnType) => void;
  onError: (error: APIErrorType) => void;
};

function SmsKey({
  mobile,
  noLabel = false,
  onSubmit,
  onUpdateMobile,
  onError
}: SmsKeyFormPropsType) {
  return (
    <Segment dataTestId='smskey-content'>
      <p className='my-6 text-center font-medium'>فرم ارسال کد احراز هویت</p>
      <hr />
      <MobileView
        mobile={mobile}
        onUpdateMobile={onUpdateMobile}
        className='text-large text-center'
      />
      <hr />
      <SmsKeyForm mobile={mobile} noLabel={noLabel} onSubmit={onSubmit} onError={onError} />
      <hr />
      <ResendView mobile={mobile} onError={onError} className='text-large mt-4 text-center' />
    </Segment>
  );
}

export default SmsKey;
